import { render, staticRenderFns } from "./WorkBookDisabledMessage.vue?vue&type=template&id=47e4623c&scoped=true&"
import script from "./WorkBookDisabledMessage.vue?vue&type=script&lang=js&"
export * from "./WorkBookDisabledMessage.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookDisabledMessage.vue?vue&type=style&index=0&id=47e4623c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4623c",
  null
  
)

export default component.exports